<template>
  <div class="overlay">
    <div class="overlay-body">
      <h1>先週一度も摂取していない食品群です。今週は摂取しましょう！！</h1>
      <div class="not-ingested-foods">
        <div v-for="foods in notIngestedFoods">
          <p class="foods-name">・{{ foods.name }}</p>
        </div>
      </div>
      <div class="img-style">
        <img src="@/assets/アセット 9@2x.png" @click="close" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotIngestedAlert",
  props: ["notIngestedFoods"],
  mounted() {
    console.log(this.notIngestedFoods, "rrrrrrrrr");
  },
  methods: {
    close() {
      this.$emit("handle-hide-dialog");
    },
  },
};
</script>

<style scoped>
.overlay {
  z-index: 5;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}

.overlay-body {
  background: white;
  margin: 10% 15px 0 15px;
  border-radius: 5px;
  /* height: 75%; */
  padding: 15px;
}
.overlay-body h1 {
  color: red;
  text-align: left;
  font-size: 1.2rem;
}
.overlay-body .foods-name {
  margin: 0;
  font-size: 1.4rem;
  display: inline-block;
  min-width: 180px;
  text-align: left;
  color: #00a0b9;
}
.overlay-body .not-ingested-foods {
  margin-bottom: 8%;
  text-align: left;
}

@media screen and (max-width:375px) and (max-height: 667px) { 
  .overlay-body .foods-name {
    font-size: 1.2rem;
  }
}

@media screen and (max-width:320px){ 
  .overlay-body .foods-name {
    min-width: 110px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NotIngestedAlert.vue